import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  ExceptionTrackingService,
  EXCEPTION_CATEGORY_ENUM,
  EXCEPTION_FILE_NAMES_ENUM,
  HttpRequestMethods,
  IExceptionMetadata
} from '@com-delta-idp/mnx-utils';
import { forkJoin, Observable, throwError } from 'rxjs';
import { IDP_APP } from '../../constants/login-constant';
import { LoginModalContent } from '../../models/aem';
import { LoginModalEndpointsKeys } from '../../models/login-modal.enum';
import {
  StoredQuestionsResponse,
  validateAnswerRequest,
  validateAnswerResponse
} from '../../models/recover-by-sqa.interface';
import { LoginContentService } from '../login-content.service';

@Injectable({
  providedIn: 'root'
})
export class RecoverSqaContentService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private exceptionTrackingService: ExceptionTrackingService,
    private contentService: LoginContentService
  ) {}

  getStoredQuestions = (): Observable<StoredQuestionsResponse> =>
    new ApiBuilder<undefined, StoredQuestionsResponse>(
      this.http,
      this.appConfig
    )
      .app('LOGIN_MODAL')
      .endpointKey(LoginModalEndpointsKeys['LOGIN_SECURITY_QUESTIONS'])
      .method(HttpRequestMethods['GET'])
      .errorHandler(this.handleError)
      .create();

  validateSecurityQuestions = (
    payload: validateAnswerRequest
  ): Observable<validateAnswerResponse> =>
    new ApiBuilder<validateAnswerRequest, validateAnswerResponse>(
      this.http,
      this.appConfig
    )
      .app('LOGIN_MODAL')
      .endpointKey(LoginModalEndpointsKeys['LOGIN_VALIDATE_SQA'])
      .method(HttpRequestMethods['POST'])
      .payload(payload)
      .errorHandler(this.handleError)
      .create();

  handleError(error: HttpErrorResponse): Observable<never> {
    const exceptionMetadata: IExceptionMetadata = {
      fileName: EXCEPTION_FILE_NAMES_ENUM.LOGIN_CONTENT_SERVICE,
      methodName: '_handleError',
      exceptionCategory: EXCEPTION_CATEGORY_ENUM.API_FAILURE,
      exceptionMessage: error.error
    };
    this.exceptionTrackingService?.track(
      `[${IDP_APP}]: ${error.status} : ${error.url}`,
      exceptionMetadata
    );
    return throwError(error);
  }

  getStaticContentForSQAScreen(): Observable<
    [LoginModalContent, StoredQuestionsResponse]
  > {
    return forkJoin([
      this.contentService.getAEMContent(),
      this.getStoredQuestions()
    ]);
  }
}
